//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SelectInput",
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: null,
      default: ""
    }
  },
  computed: {
    inputVal() {
      return this.value;
    },
    defaultSelect() {
      return this.inputVal ? "selected" : "false";
    },
    selectClassName() {
      const classes = [];
      if (this.inputVal === "" || this.inputVal === null) classes.push("select-field-empty");else classes.push("form-control-filled");
      return classes.join(" ");
    }
  },
  methods: {
    handleInput({
      target
    }) {
      let value = target.value;
      if (value === "true") {
        value = true;
      }
      if (value === "false") {
        value = false;
      }
      this.$emit("change", value);
    },
    setSelectedOption(option) {
      return option.value === this.inputVal;
    }
  }
});